import React from "react";
import "./split.css"

const Loader = () => {
    return(
        <div className="loaderOutter">
            <span className="loader"></span>
        </div>
    )
}

export default Loader;